import React from 'react';
import { connect } from 'react-redux';
import { List } from 'react-toolbox/lib/list';
import {
  addModulesDrawerDeselectAll,
  addModulesDrawerFilterQueryChanged,
  addModulesDrawerModuleSelected,
  addSelectedModules,
  hideAddModulesDrawer,
  showMoreAddModulesDrawerModules,
} from 'browse-media/redux/browseMediaActions';
import DrawerLayout from 'components/DrawerLayout';
import ListItemCountLabel from 'components/ListItemCountLabel';
import MediaListItem from 'components/MediaListItem';
import OverlayDrawer from 'components/OverlayDrawer';
import PanelLoadingIndicator from 'components/PanelLoadingIndicator';
import SeeMoreListItemsButton from 'components/SeeMoreListItemsButton';
import SelectionActionBar from 'components/SelectionActionBar';
import AddModulesDrawerFilterInput from 'browse-media/components/AddModulesDrawerFilterInput';

const isSelected = (
  module,
  selectedModuleIds,
  selectedItemsModuleIdsIntersection,
) =>
  selectedModuleIds.includes(module.id) ||
  selectedItemsModuleIdsIntersection.includes(module.id);

const isDisabled = (module, selectedItemsModuleIdsIntersection) =>
  selectedItemsModuleIdsIntersection.includes(module.id);

const isIndeterminate = (module, selectedItemsModuleIds) =>
  selectedItemsModuleIds.includes(module.id);

const AddModulesDrawer = ({
  filterQuery,
  itemCount,
  modulesLoaded,
  onAddModules,
  onClose,
  onFilterQueryChange,
  onSelected,
  onSelectionActionBarBack,
  onShowMore,
  selectedMediaIds,
  selectedItemsModuleIds,
  selectedItemsModuleIdsIntersection,
  selectedModuleIds,
  visible,
  visibleModules,
}) =>
  <OverlayDrawer active={visible} onClickBackdrop={onClose}>
    <DrawerLayout
      onClose={onClose}
      header={
        <div>
          <AddModulesDrawerFilterInput />
          <ListItemCountLabel itemCount={itemCount} itemTypes="Modules" />
          {selectedModuleIds.length > 0 &&
            <SelectionActionBar
              addText="Add content"
              onAdd={onAddModules}
              onBack={onSelectionActionBarBack}
              selectedCount={selectedModuleIds.length}
            />}
        </div>
      }
    >
      {modulesLoaded
        ? <List selectable ripple>
            {visibleModules.map(module =>
              <MediaListItem
                disabled={isDisabled(
                  module,
                  selectedItemsModuleIdsIntersection,
                )}
                indeterminate={isIndeterminate(module, selectedItemsModuleIds)}
                key={module.id}
                media={module}
                onSelected={onSelected}
                selected={isSelected(
                  module,
                  selectedModuleIds,
                  selectedItemsModuleIdsIntersection,
                )}
              />,
            )}
          </List>
        : <PanelLoadingIndicator />}
      {modulesLoaded &&
        itemCount > visibleModules.length &&
        <SeeMoreListItemsButton onClick={onShowMore} />}
    </DrawerLayout>
  </OverlayDrawer>;

const mapStateToProps = state => {
  const { browseMedia } = state;

  const {
    selectedMediaIds,
    selectedItemsModuleIds,
    selectedItemsModuleIdsIntersection,
  } = browseMedia;

  const {
    itemCount,
    modulesLoaded,
    selectedModuleIds,
    visible,
    visibleModules,
  } = browseMedia.addModulesDrawer;

  return {
    itemCount,
    modulesLoaded,
    selectedItemsModuleIds,
    selectedItemsModuleIdsIntersection,
    selectedMediaIds,
    selectedModuleIds,
    visible,
    visibleModules,
  };
};

const mapDispatchToProps = dispatch => ({
  onAddModules: () => dispatch(addSelectedModules()),
  onClose: () => dispatch(hideAddModulesDrawer()),
  onFilterQueryChange: value =>
    dispatch(addModulesDrawerFilterQueryChanged(value)),
  onSelected: (selected, moduleId) =>
    dispatch(addModulesDrawerModuleSelected(selected, moduleId)),
  onSelectionActionBarBack: () => dispatch(addModulesDrawerDeselectAll()),
  onShowMore: () => dispatch(showMoreAddModulesDrawerModules()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddModulesDrawer);
